import { AlertTriangle } from 'lucide-react';

interface Props {
  onRetry: () => void;
  onSignOut: () => void;
}

/**
 * Shown when the user is authenticated but their profile failed to load
 * (network blip, timeout, or RLS error). Prevents the app from rendering in a
 * degraded "no role" state or hanging on the initial spinner.
 */
export function ProfileLoadError({ onRetry, onSignOut }: Props) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
          <AlertTriangle className="w-7 h-7 text-amber-600" />
        </div>
        <h2 className="text-xl font-bold text-slate-900 mb-2">Couldn't load your profile</h2>
        <p className="text-sm text-slate-600 mb-6">
          We couldn't load your account details just now — this is usually a temporary network
          issue. Please try again.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={onRetry}
            className="px-5 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-semibold"
          >
            Try Again
          </button>
          <button
            onClick={onSignOut}
            className="px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
